module.exports = __webpack_public_path__ + "images/pushNotificationIcon-167e3b5c4e03ae9851471ede86b3bcdb.svg";